var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LMarker',{ref:"marker",attrs:{"lat-lng":_vm.convertLatLng(_vm.restaurant.location)},on:{"click":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }